const systemText = {
    ko: {
        'myName': '양준형',
        'frontEndDevloper': '프론트엔드 개발자',
        'fullStackDevloper': '풀스택 개발자',
        'about': '소개',
        'profile': '프로필',
        'workExperience': '경력사항',
        'skills': '스킬',
        'study': '교육',
        'projects': '프로젝트',
        'contact': '문의',

        'address': '주소',
        'myAddress': '아일랜드 더블린',
        'phone': '전화번호',
        'myPhone': '010-9164-1201',
        'email': '이메일',
        'myEmail': 'y.junh0y@gmail.com',
        'aboutMe': '&nbsp;React와 TypeScript를 기반으로 사용자 경험을 중심에 두고 프론트엔드 개발을 해왔습니다. GenAI 기반 사내 서비스 개발을 통해 복잡한 기능을 직관적인 UI/UX로 구현하는 경험을 쌓아왔으며, 디자인 시스템 구축과 타입 안정성을 고려한 프론트엔드 구조 설계에 강점을 가지고 있습니다. <br />&nbsp;PHP(Laravel) 기반의 풀스택 개발 경험을 바탕으로 백엔드 및 비즈니스 요구사항을 이해하고, 기획·디자인·개발 간 협업 과정에서 프론트엔드 개발자로서의 역할을 주도적으로 수행해왔습니다. 또한 해외 웹 에이전시 및 프리랜서 경험을 통해 다양한 요구사항에 유연하게 대응하며, 서비스 품질과 사용자 관점을 함께 고려해 개발해왔습니다.',
        'content': '내용',
        'sendEmail': '이메일 발송',
        'emailAlert': '이메일 주소를 입력하세요.',
        'contentAlert': '내용을 입력하세요.',
        'sendSuccess': '이메일 발송이 완료되었습니다.',

        'favoriteMedium': '페이버릿 미디엄',
        'favoriteMediumDate': '2025.05 - 2025.12',
        'favoriteMediumRole': '프론트엔드 개발자',
        'favoriteMediumDescription': '· GS 칼텍스 사내 GenAI 서비스 개발 </br>· React/TypeScript 기반 프론트엔드 개발 및 UI/UX 개선 </br>· Tailwind CSS를 활용한 디자인 시스템 구축 및 유지보수 </br>· Figma, Jira, Confluence 기반 스크럼/애자일 협업 경험 </br>· GitOps 기반 배포 자동화 운영 (AWS CodeCommit, Docker, ArgoCD)',

        'arrowDesign': 'Arrow Design',
        'arrowDesignDate': '2024.08 - 2025.03',
        'arrowDesignRole':  'Software Architect',
        'arrowDesignDescription': '· PHP (WordPress) 기반 웹사이트 및 커머스 플랫폼 개발 </br>· 커스텀 WordPress 테마 및 플러그인 개발 </br>· MySQL을 활용한 데이터베이스 설계 및 최적화',

        'ctk': '씨티케이',
        'ctkCosmetics': '씨티케이 코스메틱스',
        'ctkClip': 'CTKCLIP',
        'forPartner': '파트너 사이트',
        'forAdmin': '어드민 사이트',

        'ctkDate': '2022.04 - 2024.04',
        'ctkRole': '풀스택 개발자 / 매니저',
        'ctkDescription': '· 플랫폼 사이트 개발 및 유지보수 (PHP, Laravel) </br>· 플랫폼 파트너 사이트 개발 및 유지보수 (vue.js) <br/>· 성분 스크리닝 페이지 기획 및 개발',

        'innerbottle': '이너보틀',
        'innerbottleDate': '2019.06 - 2021.06',
        'innerbottleRole': '선임연구원',
        'innerbottleDescription': '· 제품 개발 및 품질 업무 담당 <br />· 생산 기술 개발 및 공정 확립',

        'viewProjects': '프로젝트 보기',
        'goToTheSite': '사이트 이동',

        'portfolio': '포트폴리오',
        'portfolioDesc': '개인 포트폴리오 사이트',

        'musizic': '뮤지직',
        'musizicDate': '2024.12 - 2025.05',
        'musizicRole': '프론트엔드 개발',
        'musizicDesc': '· 플랫폼 사이트 개발 및 유지보수 (React, Next.js, TypeScript) </br>· SEO 최적화 </br>· 웹 디자인 & UI/UX 기획',

        'frontEnd': '프론트엔드',
        'backEnd': '백엔드',
        'others': '기타',
        'certificates': '자격증',
        'certificate1': '웹디자인개발기능사 (2025)',
        'languages': '언어',
        'korean': '한국어 (원어민)',
        'english': '영어 (중급)',
        'englishExtra1': '· 전시회 고객 응대 (코스모프로프 2019, 2022)',
        'englishExtra2': '· 외부 API 관련 이메일 소통',
        'englishExtra3': '· 아일랜드 웹 에이전시 근무',

        'kosmo': '한국소프트웨어인재개발원',
        'kosmoDate': '2021.09 - 2022.03',
        'kosmoDesc': '풀스택 과정 수료 및 개발 프로젝트 수행',

        'hongik': '홍익대학교',
        'hongikDate': '2010.03 - 2017.02',
        'hongikMajor': '기계시스템디자인공학 (학사)',
        'hongikMinor': '도예유리 (부전공)',
    },
    en: {
        'myName': 'Jun Hyeong Yang',
        'frontEndDevloper': 'Front-end Developer',
        'fullStackDevloper': 'Full-stack Developer',
        'about': 'About',
        'profile': 'Profile',
        'workExperience': 'Work Experience',
        'skills': 'Skills',
        'study': 'Study',
        'projects': 'Projects',
        'contact': 'Contact',
        'sendEmail': 'Send an email',

        'address': 'Address',
        'myAddress': 'Dublin, Ireland',
        'phone': 'Phone',
        'myPhone': '010-9164-1201',
        'email': 'Email',
        'myEmail': 'y.junh0y@gmail.com',
        'aboutMe': '&nbsp;I am a frontend developer with a strong focus on user experience, working primarily with React and TypeScript. Through the development of an internal GenAI-based service, I have gained experience in translating complex functionality into intuitive UI/UX, while building frontend architectures with an emphasis on design systems and type safety. <br />&nbsp;With prior full-stack experience using PHP (Laravel), I have a solid understanding of backend systems and business requirements. I have worked closely with planning, design, and development teams, taking an active role as a frontend developer throughout the collaboration process. In addition, my experience in overseas web agencies and freelance projects has enabled me to adapt quickly to diverse requirements while consistently balancing service quality and user perspective.',
        'content': 'Content',
        'emailAlert': 'Please enter an email address.',
        'contentAlert': 'Please enter content.',
        'sendSuccess': 'The email has been sent successfully.',

        'favoriteMedium': 'Favorite Medium',
        'favoriteMediumDate': 'MAY 2025 - DEC 2025',
        'favoriteMediumRole': 'Front-end Developer',
        'favoriteMediumDescription': '· Development of an internal GenAI service at GS Caltex </br>· Frontend development and UI/UX improvements using React and TypeScript </br>· Design system development and maintenance with Tailwind CSS </br>· Agile Scrum collaboration using Figma, Jira, and Confluence </br>· GitOps-based deployment automation (AWS CodeCommit, Docker, ArgoCD)',

        'arrowDesign': 'Arrow Design',
        'arrowDesignDate': 'AUG 2024 - MAR 2025',
        'arrowDesignRole':  'Software Architect',
        'arrowDesignDescription': '· Developed WordPress-based websites and e-commerce platforms. </br>· Designed and developed custom WordPress themes and plugins. </br>· Designed and optimized databases using MySQL.',

        'ctk': 'CTK',
        'ctkCosmetics': 'CTK Cosmetics',
        'ctkClip': 'CTKCLIP',
        'forPartner': 'for Partner',
        'forAdmin': 'for Admin',

        'ctkDate': 'APR 2022 - APR 2024',
        'ctkRole': 'Full-stack Developer / Assistant Manager',
        'ctkDescription': '· Developed and maintained web applications using PHP, Laravel, and vue.js. <br />· Collaborated with UI/UX designers to enhance user experience. <br />· Developed regulatory screening functionality as a full-stack developer (planning, database design, API development). <br />· Communicated in English via email regarding external APIs and handled customer interactions in English at exhibitions. <br />· Managed development outsourcing vendors.',

        'innerbottle': 'Innerbottle',
        'innerbottleDate': 'JUN 2019 - JUN 2021',
        'innerbottleRole': 'Researcher',
        'innerbottleDescription': '· Researched, devloped and assured quality to cosmetic packages. <br />· Developed and improved a production technology & process.',

        'viewProjects': 'View projects',
        'goToTheSite': 'Go to the site',

        'portfolio': 'Portfolio',
        'portfolioDesc': 'Personal portfolio site',

        'musizic': 'MUSIZIC',
        'musizicDate': 'DEC 2024 - MAY 2025',
        'musizicRole': 'Front-end Developer',
        'musizicDesc': '· Developed and maintained the platform website using React, Next.js, and TypeScript. </br>· Optimized SEO for better search visibility </br>· Designed the overall web UI/UX',

        'frontEnd': 'Front-end',
        'backEnd': 'Back-end',
        'others': 'Others',
        'certificates': 'Certificates',
        'certificate1': 'Craftsman Web Design Development (2025, Korea)',
        'languages': 'Langauges',
        'korean': 'Korean (Native)',
        'english': 'English (Intermediate)',
        'englishExtra1': '· Handled customer service at exhibitions (Cosmoprof 2019, 2022)',
        'englishExtra2': '· Communicated via email regarding external APIs',
        'englishExtra3': '· Worked at a web agency in Ireland',

        'kosmo': 'KOSMO',
        'kosmoDate': 'SEP 2021 - MAR 2022',
        'kosmoDesc': 'Completed a full-stack programming class and developed some projects.',

        'hongik': 'Hongik University',
        'hongikDate': 'MAR 2010 - FEB 2017',
        'hongikMajor': 'Mechanical System Design Engineering (BA)',
        'hongikMinor': 'Ceramic & Class (Minor)',
    },
};

export default systemText;